import React from 'react';

export const TrustedBySection: React.FC = () => {
  const logos = [
     { name: 'Bruta Burger', category: 'Fast Food & Delivery' },
     { name: 'Clínica Excellence', category: 'Saúde & Odonto' },
     { name: 'Imobiliária Prime', category: 'Imóveis & Lançamentos' },
     { name: 'Hortofertas Super', category: 'Supermercados' },
     { name: 'BioLink Pro', category: 'Infoprodutos' },
  ];

  return (
    <section className="py-12 px-4 bg-slate-50 border-y border-slate-200/60 font-sans">
      <div className="max-w-7xl mx-auto space-y-6 text-center">
         <span className="text-xs font-bold uppercase tracking-widest text-slate-400">
            EMPRESAS E SECTORES ATENDIDOS PELO ECOSSISTEMA YOUMACHINE
         </span>
         
         <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16 pt-2">
            {logos.map((logo, idx) => (
               <div 
                  key={idx} 
                  className="flex items-center gap-2 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300 cursor-pointer"
               >
                  <div className="w-8 h-8 rounded-lg bg-slate-900 text-white font-black flex items-center justify-center text-xs">
                     {logo.name.charAt(0)}
                  </div>
                  <div className="text-left">
                     <strong className="block text-xs font-black text-slate-900 leading-none">{logo.name}</strong>
                     <span className="text-[9px] text-slate-500 font-medium">{logo.category}</span>
                  </div>
               </div>
            ))}
         </div>
      </div>
    </section>
  );
};
